import { ReactActionType } from "@input-output-hk/essential-cardano-models";
import React from "react";
import styled from "styled-components";
import { InlineSeparator } from "./InlineSeparator";
import { CommentCountLink, ContributeCountLink } from "./ItemIconAndCountLinks";
import { PosterInformation } from "./PosterInformation";
import { Tags } from "./Tags";
import Vote from "../vote/Vote";
import { Item } from "../../data/db/types";
import {
  forTabletPortraitDown,
  forTabletPortraitUp
} from "../../tokens/media-queries";

const ArticleMetaElement = styled.div`
  --article-meta-item-gap: var(--spacing-default);

  position: relative;
  display: flex;
  margin-top: var(--spacing-xlarge);
  margin-bottom: var(--spacing-xlarge);

  @media ${forTabletPortraitUp} {
    --article-meta-item-gap: var(--spacing-large);
    align-items: center;

    & > * + * {
      margin-left: var(--article-meta-item-gap);
    }

    [data-poster-info] {
      --poster-information-gap: var(--article-meta-item-gap);
    }
    [data-vote] {
      --vote-button-gap: var(--article-meta-item-gap);
    }
    [data-verified-label] {
      margin-top: var(--spacing-default);
      margin-bottom: var(--spacing-default);
    }
    [data-tags] {
      margin-left: auto;
    }
  }

  @media ${forTabletPortraitDown} {
    flex-direction: column;

    & > * + * {
      margin-top: var(--article-meta-item-gap);
    }

    ${InlineSeparator} {
      display: none;
    }
    [data-article-date] {
      margin-left: auto;
    }
  }

  [data-poster-info] {
    flex-shrink: 0;
  }
`;

const ArticleVote = styled(Vote)``;
const MinorCtas = styled.div`
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: var(--article-meta-item-gap);
  }
`;

export function ArticleMeta({
  item,
  verifiedContentElement,
  myVote,
  handleClickVote,
  isLoading,
  upvoteCount,
  downvoteCount,
  adminElement
}: {
  item: Item;
  verifiedContentElement: JSX.Element | null;
  myVote: ReactActionType | undefined;
  handleClickVote: ((type: ReactActionType) => Promise<void>) | (() => void);
  isLoading: boolean;
  upvoteCount: number;
  downvoteCount: number;
  adminElement: JSX.Element | null;
}) {
  return (
    <ArticleMetaElement>
      <PosterInformation item={item} level="1" />
      {verifiedContentElement}
      <InlineSeparator />
      <MinorCtas>
        <ArticleVote
          myVote={myVote}
          onClick={handleClickVote}
          disabled={isLoading}
          upvoteCount={upvoteCount}
          downvoteCount={downvoteCount}
          totalCount={item._upvoteScore || 0}
        />
        <CommentCountLink count={item.commentCount} href="" />
        <ContributeCountLink count={item._contributions.length} href="" />
      </MinorCtas>
      <Tags tags={item._tags} />
      {adminElement}
    </ArticleMetaElement>
  );
}
